"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBenchmarkObservable = void 0;
var immer_1 = require("immer");
var rxjs_1 = require("rxjs");
var __1 = require("..");
var NQError_1 = require("../NQError");
var localStorage_1 = require("../util/localStorage");
var observable_1 = require("../util/observable");
var R = __importStar(require("ramda"));
var JetStream1 = __importStar(require("./Benchmarks/JetStream1"));
var JetStream2 = __importStar(require("./Benchmarks/JetStream2"));
function pastBenchmarkResult(logger) {
    var data = (0, localStorage_1.getBenchmarkResult)(logger);
    if (data === null) {
        return null;
    }
    if (Date.now() - data.timestamp < 30 * 24 * 3600 * 1e3) {
        return [
            {
                kind: __1.NQValueKind.BenchmarkIntermediate,
                result1: data.result1,
            },
            {
                kind: __1.NQValueKind.BenchmarkFinalAvailable,
                result1: data.result1,
                result2: data.result2,
            }
        ];
    }
    else {
        return null;
    }
}
function saveResult(results) {
    var r1 = results[0], r2 = results[1];
    if (r1 === undefined ||
        r2 === undefined ||
        r1.kind !== __1.NQValueKind.BenchmarkIntermediate ||
        r2.kind !== __1.NQValueKind.BenchmarkFinalAvailable) {
        return (0, rxjs_1.throwError)(function () { return new NQError_1.NQInternalError(NQError_1.NQInternalErrorCode.IllegalBenchmarkResultsValues, "got: ".concat(JSON.stringify(results))); });
    }
    ;
    var data = {
        timestamp: Date.now(),
        result1: r1.result1,
        result2: r2.result2,
    };
    (0, localStorage_1.setBenchmarkResult)(data);
    return rxjs_1.EMPTY;
}
var computeGeomeans = function (measurements) {
    var sum = R.sum(measurements.map(Math.log));
    return Math.exp(sum * (1 / measurements.length));
};
var runBenchmarks = function (benchmarks, logger) { return __awaiter(void 0, void 0, void 0, function () {
    var measurements, _i, benchmarks_1, b, m;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                measurements = [];
                _i = 0, benchmarks_1 = benchmarks;
                _a.label = 1;
            case 1:
                if (!(_i < benchmarks_1.length)) return [3 /*break*/, 4];
                b = benchmarks_1[_i];
                return [4 /*yield*/, b.measure()];
            case 2:
                m = _a.sent();
                measurements.push(m);
                _a.label = 3;
            case 3:
                _i++;
                return [3 /*break*/, 1];
            case 4:
                logger.debug("BENCHMARKS runBenchmarks, measurements = ".concat(JSON.stringify(measurements)));
                return [2 /*return*/, computeGeomeans(measurements)];
        }
    });
}); };
var runBenchmarkObservable = function (logger) { return new rxjs_1.Observable(function (subscriber) {
    (function asyncExecutionContext() {
        return __awaiter(this, void 0, void 0, function () {
            var pastResult, result1, _a, _b, result2, _c, _d, err_1;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 5, , 6]);
                        if (typeof document !== "object" || typeof window !== "object") {
                            subscriber.complete();
                            return [2 /*return*/];
                        }
                        pastResult = pastBenchmarkResult(logger);
                        if (pastResult != null) {
                            pastResult.forEach(function (r) { return subscriber.next(r); });
                            subscriber.complete();
                            return [2 /*return*/];
                        }
                        _b = (_a = Math).round;
                        return [4 /*yield*/, runBenchmarks([new JetStream1.NBodyBenchmark(logger), new JetStream1.HashMapBenchmark(logger)], logger)];
                    case 1:
                        result1 = _b.apply(_a, [_e.sent()]);
                        logger.info("messageEventHandler got result1: ".concat(result1));
                        subscriber.next((0, immer_1.freeze)({
                            kind: __1.NQValueKind.BenchmarkIntermediate,
                            result1: result1,
                        }));
                        if (!(result1 > 40)) return [3 /*break*/, 3];
                        _d = (_c = Math).round;
                        return [4 /*yield*/, runBenchmarks([
                                new JetStream2.Cube3DBenchmark(logger),
                                new JetStream2.Box2DBenchmark(logger),
                                new JetStream2.NBodyCBenchmark(logger),
                                new JetStream2.DryCBenchmark(logger),
                                new JetStream2.QuicksortCBenchmark(logger),
                                new JetStream2.RegexDnaBenchmark(logger),
                                new JetStream2.TowersCBenchmark(logger)
                            ], logger)];
                    case 2:
                        result2 = _d.apply(_c, [_e.sent()]);
                        logger.info("messageEventHandler got result2: ".concat(result2));
                        subscriber.next((0, immer_1.freeze)({
                            kind: __1.NQValueKind.BenchmarkFinalAvailable,
                            result1: result1,
                            result2: result2,
                        }));
                        subscriber.complete();
                        return [3 /*break*/, 4];
                    case 3:
                        subscriber.next((0, immer_1.freeze)({
                            kind: __1.NQValueKind.BenchmarkFinalAvailable,
                            result1: result1,
                            result2: null,
                        }));
                        subscriber.complete();
                        _e.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        err_1 = _e.sent();
                        subscriber.error(err_1);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    })();
    function dispose() {
    }
    ;
    return dispose;
}); };
var getBenchmarkObservable = function (logger) { return runBenchmarkObservable(logger).pipe((0, observable_1.summarizeThrough)(saveResult), (0, rxjs_1.timeout)(90000), (0, rxjs_1.timeInterval)()); };
exports.getBenchmarkObservable = getBenchmarkObservable;
//# sourceMappingURL=BenchmarkController.js.map